import React from 'react';
import { useHistory } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import { Button } from 'antd';
import API from "../Services/BaseService";
import checkImg from '../../src/assets/img/check.svg';
import '../assets/css/responsive.css';
import PageNotFound from '../Container/FallBackUI/PageNotFound';

const Email = () => {
    const history = useHistory();
    // const { id } = useParams();
    let value = window.location.href.split("id=");
    const [status, setValue] = useState("");
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    async function handleclick() {

        console.log("check", value[1])
        let request = {
            seller_request_id: value[1]
        };
        console.log("check request====", request)
        API.post("seller_active/update", request)
            .then((response) => {
                // console.log("res====", response.data.success)
                // console.log("res====8956", response.data.error.err)
                // if (response.data.success === true) {
                    if (response.data.success) {
                        setValue(response.data.success);
                        localStorage.setItem('status', 'no');
                        //history.push("/emailsuccess");
                        history.push("/email");
                    } else {
                        history.push("/error");
                    }
                // }
                // else {
                //     setErrors(response.data.error.err)
                //     setErrorFlag(true)
                // }

            })
           

            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });

    }
    useEffect(() => {
        handleclick();
    }, []);

    return (
        <div>
                <main id="main" className="inner-page">
            {errorFlag === true ? <PageNotFound error={errors} /> :

                    <div id="Successfullform" className="Successfullform">
                        <div className="container">
                            <div className="Successfullformblock col-lg-6">
                                <div className="row content">
                                    <div className="modalcontent">
                                        <div className="Successfull-icon">
                                            <img alt="" src={checkImg} />
                                        </div>
                                        <div className="modalbody">
                                            <p>Your email has successfully been activated.</p>
                                            <p>Ursecondlot admin will contact you soon.</p>
                                            <Button className="get-started-btn" onClick={() => history.push("/login")}>Dealer Login</Button>

                                        </div>


                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>}
                </main>

        </div>
    );
};

export default Email;